"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/Popover/Popover.context.ts
const [PopoverContextProvider, usePopoverContext] = createSafeContext("Popover component was not found in the tree");
//#endregion
export { PopoverContextProvider, usePopoverContext };

//# sourceMappingURL=Popover.context.mjs.map